import React from "react";
import styles from "./Customer.module.css";

function Customer({ img, name, imageAlt }) {
  return (
    <div className={`${styles.customerCont} customer__cont`}>
      <div className={`${styles.customer} `}>
        <div className={`${styles.customerLogo}`}>
          <img src={img} alt={imageAlt} />
        </div>
        <div className={styles.customerName}>
          <h3>{name}</h3>
        </div>
      </div>
    </div>
  );
}

export default Customer;
